module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-64.fc4c863a.svg";